import { render, staticRenderFns } from "./DashboardPlusV2.vue?vue&type=template&id=6a5878b6&scoped=true"
import script from "./DashboardPlusV2.vue?vue&type=script&lang=js"
export * from "./DashboardPlusV2.vue?vue&type=script&lang=js"
import style0 from "./DashboardPlusV2.vue?vue&type=style&index=0&id=6a5878b6&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a5878b6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a5878b6')) {
      api.createRecord('6a5878b6', component.options)
    } else {
      api.reload('6a5878b6', component.options)
    }
    module.hot.accept("./DashboardPlusV2.vue?vue&type=template&id=6a5878b6&scoped=true", function () {
      api.rerender('6a5878b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/DashboardPlusV2.vue"
export default component.exports